// Product schedule (LinkedIn content calendar) - one doc per year
// Access: admin and editor only (enforced in Firestore rules)
import {
  doc,
  getDoc,
  setDoc,
  serverTimestamp
} from 'firebase/firestore'
import { db } from './config'

const PRODUCT_SCHEDULE_COLLECTION = 'productSchedule'

/**
 * Get product schedule edits for a year from Firestore.
 * Returns an object keyed by productId -> monthIndex (string) -> { theme?, contentReady?, ... }.
 * @param {number} year - Year (e.g. 2025)
 * @returns {Promise<Object>} Edits for that year, or {} if none
 */
export const getProductSchedule = async (year) => {
  try {
    const ref = doc(db, PRODUCT_SCHEDULE_COLLECTION, String(year))
    const snap = await getDoc(ref)
    if (!snap.exists()) return {}
    const data = snap.data()
    // Omit metadata fields
    const { updatedAt, ...edits } = data
    return edits
  } catch (error) {
    console.error('Error getting product schedule:', error)
    throw error
  }
}

/**
 * Save product schedule edits for a year to Firestore.
 * Only admin/editor can write (enforced by rules).
 * @param {number} year - Year (e.g. 2025)
 * @param {Object} edits - Nested object: productId -> monthIndex -> { theme?, contentReady?, ... }
 * @returns {Promise<void>}
 */
export const saveProductSchedule = async (year, edits) => {
  try {
    const ref = doc(db, PRODUCT_SCHEDULE_COLLECTION, String(year))
    await setDoc(ref, {
      ...edits,
      updatedAt: serverTimestamp()
    }, { merge: true })
  } catch (error) {
    console.error('Error saving product schedule:', error)
    throw error
  }
}
